// Thème basé sur constants/light.ts de l'application mobile
export interface ThemeColors {
  text: string;
  primary: string;
  secondary: string;
  tertiary: string;
  black: string;
  white: string;
  dark: string;
  light: string;
  gray: string;
  danger: string;
  warning: string;
  success: string;
  info: string;
  background: string;
  card: string;
  shadow: string;
  overlay: string;
  focus: string;
  input: string;
  blue: string;
  green: string;
}

export const colors: ThemeColors = {
  text: "#252F40",
  primary: "#b4840e",
  secondary: "#22272fff",
  tertiary: "#b4840e",
  black: "#0f0f0f",
  white: "#FFFFFF",
  dark: "#0f0f0f",
  light: "#E9ECEF",
  gray: "#A7A8AE",
  danger: "#EA0606",
  warning: "#b4840e",
  success: "#82D616",
  info: "#17C1E8",
  background: "#E9ECEF",
  card: "#FFFFFF",
  shadow: "#000000",
  overlay: "rgba(0,0,0,0.3)",
  focus: "#E293D3",
  input: "#252F40",
  blue: "#1E90FF",
  green: "#28A745",
};

export const sizes = {
  base: 8,
  text: 14,
  radius: 4,
  padding: 20,
  h1: 44,
  h2: 40,
  h3: 32,
  h4: 24,
  h5: 18,
  p: 16,
  buttonRadius: 8,
  inputHeight: 46,
  inputRadius: 8,
  inputPadding: 12,
  cardRadius: 16,
  cardPadding: 10,
  xs: 4,
  s: 8,
  sm: 16,
  m: 24,
  md: 32,
  l: 40,
  xl: 48,
  xxl: 56,
};

export const gradients = {
  primary: ["#FF0080", "#7928CA"],
  secondary: ["#A8B8D8", "#627594"],
  info: ["#21D4FD", "#2152FF"],
  success: ["#98EC2D", "#17AD37"],
  warning: ["#b4840e", "#fbb400"],
  danger: ["#FF667C", "#EA0606"],
  light: ["#EBEFF4", "#CED4DA"],
  dark: ["#3A416F", "#141727"],
};
